import { DestinationType } from 'types/Destination';

export const DestinationTypeDescription = {
	[DestinationType.CACC]: 'Conta Corrente',
	[DestinationType.SVGS]: 'Conta poupança',
	[DestinationType.TRAN]: 'Conta de pagamentos',
	[DestinationType.SLRY]: 'Conta salário',
};
